<template>
	<div class="row my-4">
		<div class="row mb-2">
			<h5 class="bg-info p-2">Package Details</h5>
		</div>
		<div class="col-sm-12">
			<div class="row">
				<div class="form-group col-sm-3 mb-4">
					<BaseInput
						name="TourDate"
						label="Tour Start Date"
						type="date"
						:min="
							data.startDate
								? data.startDate
								: `${new Date().getFullYear()}-${
										new Date().getMonth() + 1 < 10
											? '0' + (new Date().getMonth() + 1)
											: new Date().getMonth() + 1
								  }-${new Date().getDate() + 1}`
						"
						v-model="data.startDate"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="valError"
						@valSuccess="valSuccess"
					/>
				</div>
				<div class="form-group col-sm-3 mb-4">
					<BaseInput
						name="TourEndDate"
						label="Tour End Date"
						type="date"
						:min="data.startDate"
						v-model="data.endDate"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="valError"
						@valSuccess="valSuccess"
					/>
				</div>
				<div class="form-group col-sm-3 mb-4">
					<BaseInput
						name="Budget"
						label="Budget"
						type="number"
						:min="2000"
						v-model="data.budget"
						class="form-control form-control-lg dashInput"
						rules="required"
						@valError="valError"
						@valSuccess="valSuccess"
					/>
				</div>
			</div>
		</div>

		<div class="row my-2">
			<h5 class="bg-info p-2 text-dark">Select Hotel / Package</h5>
		</div>
		<div class="row">
			<div class="form-group col-sm-6 mb-4">
				<BaseMultiSelect
					@update:value="setCountry"
					:options="multiSelectState.countriesSelect"
					:defaultData="data?.country?.id"
					rules="required"
					name="Select Country"
					mode="single"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>
			<div class="form-group col-sm-6 mb-4">
				<BaseMultiSelect
					@update:value="setState"
					@change:value="getStates"
					:options="multiSelectState.statesSelect"
					:defaultData="data?.state?.id"
					rules="required"
					name="Select State"
					mode="single"
					@valError="valError"
					@valSuccess="valSuccess"
				/>
			</div>

			<div
				v-if="packagesData.packages.length"
				class="form-group col-sm-12 mb-4"
			>
				<h5 class="text-dark bg-warning py-2 px-2">Available Packages</h5>
				<div v-if="!packagesData.packages.length" class="row">
					{{ packageData.message }}
				</div>
				<div v-else class="row px-2">
					<div
						v-for="(packageData, index) in packagesData.packages"
						:key="`${index}-package`"
						class="col-sm-4 d-flex align-items-center"
					>
						<input
							class="form-check-input"
							type="radio"
							:id="`Checkbox-${packageData.name}`"
							:value="packageData._id"
							v-model="packagesData.selectedPackage"
							@change="showPackage(packageData._id)"
						/>
						<label
							class="form-check-label mx-2 text-dark"
							:for="`Checkbox-${packageData.name}`"
							>{{ packageData.name }}</label
						>
					</div>
				</div>

				<div
					v-if="packagesData.selectedPackage && !data.edited"
					class="row my-4 px-4"
				>
					<div class="row bg-warning py-2 fs-5">
						<div class="col-sm-5 text-dark">
							{{ data.packageData?.name }}
						</div>
						<div class="col-sm-1 text-dark">
							{{ data.packageData?.country?.name }}
						</div>
						<div class="col-sm-2 text-dark">
							{{ packagesData?.nights }} Nights/ {{ packagesData?.days }} Days
						</div>
						<div class="col-sm-4 d-flex justify-content-end">
							<input
								class="form-check-input"
								type="checkbox"
								id="editPackage"
								value="editPackage"
								v-model="data.edited"
								@change="editPackage(data.packageData._id)"
							/>
							<label class="form-check-label mx-2 text-dark" for="editPackage"
								>Edit Package</label
							>
						</div>
					</div>

					<div class="row my-4">
						<div class="col-sm-6">
							<p class="bg-warning px-1 py-2 text-dark">
								The Package Cost Includes
							</p>
							<span class="m-0 text-dark" v-html="data.packageData?.inclusions">
							</span>
						</div>
						<div class="col-sm-6">
							<p class="bg-warning px-1 py-2 text-dark">
								The Package Cost Excludes
							</p>

							<span
								class="m-0 text-dark"
								v-html="data.packageData?.exclusions"
							></span>
						</div>
					</div>
				</div>
				<div
					v-if="packagesData.selectedPackage && data.edited"
					class="row my-4 px-4"
				>
					<PackageEdit :leadPackage="true" />
				</div>

				<div
					v-if="packagesData.selectedPackage"
					class="row my-4 bg-warning py-2"
				>
					<div class="col-sm-12 d-flex align-items-center">
						<input
							class="form-check-input"
							type="checkbox"
							id="savePackage"
							value="savePackage"
							v-model="miscState.hotelsAndVehicles"
						/>
						<label
							class="form-check-label mx-2 text-dark fs-4"
							for="savePackage"
							>Add Day Wise Itinerary</label
						>
					</div>
				</div>

				<div v-if="miscState.hotelsAndVehicles" class="row my-4 px-4">
					<div class="col-sm-12 d-flex align-items-center">
						<CreateItinerary
							name="Edit"
							:leadPackage="true"
							:count="miscState.itineraryCount"
							@updateItinerary="updateItinerary"
							:defaultData="data.itinerary"
						/>
					</div>
				</div>

				<div v-if="data.edited" class="row my-4 bg-warning py-2">
					<div class="col-sm-6 d-flex align-items-center">
						<input
							class="form-check-input"
							type="checkbox"
							id="savePackage"
							value="savePackage"
							v-model="miscState.savePackage"
							@change="savePackage(data.packageData._id)"
						/>
						<label
							class="form-check-label mx-2 text-dark fs-4"
							for="savePackage"
							>Save package Changes</label
						>
					</div>
				</div>
			</div>

			<div
				v-if="packagesData.packagesFetched && !packagesData.packages.length"
				class="form-group row mb-4"
			>
				<div class="col-sm-12">
					<p class="text-danger">No packages available for selected city</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { inject, reactive, watchEffect, onBeforeUnmount } from "vue";

	import Data from "@/helpers/dataHelper";
	import Helper from "@/helpers/dataHelper";
	import API from "@/config/api";

	import BaseInput from "@/components/BaseInput";
	import BaseMultiSelect from "@/components/BaseMultiSelect";
	import PackageEdit from "@/components/PackageEdit";
	import CreateItinerary from "@/components/CreateItinerary";

	export default {
		name: "LeadPackage",
		components: {
			BaseInput,
			BaseMultiSelect,
			PackageEdit,
			CreateItinerary,
		},
		setup: () => {
			const store = inject("store");
			const masterStore = inject("masterStore");
			const packageEditState = inject("packageEditState");
			const leadState = inject("leadState");

			const geoData = reactive({
				countrySelected: false,
				citySelected: false,
				stateSelected: false,
			});

			const multiSelectState = reactive({
				roomTypes: [],
				countries: [],
				countriesSelect: [],
				states: [],
				statesSelect: [],
				cities: [],
				citiesSelect: [],
				hotels: [],
				hotelsSelect: [],
			});

			const packagesData = reactive({
				packages: [],
				packagesFetched: false,
				selectedPackage: null,
				editSelectedPackage: false,
				message: "No packages found!",
				nights: 0,
				days: 0,
			});

			const miscState = reactive({
				savePackage: false,
				hotelsAndVehicles: false,
				itineraryCount: 0,
			});

			const data = reactive({
				status: true,
				startDate: null,
				endDate: null,
				budget: null,
				edited: false,
				country: {
					id: 0,
					name: null,
				},
				state: {
					id: 0,
					name: null,
				},
				packageId: null,
				packageData: {},
				itinerary: [],
			});

			const formState = reactive({
				isLoading: false,
				disable: true,
			});

			// Country, City, State related Functions start
			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					multiSelectState.countries = countries;
					multiSelectState.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
				} catch (error) {
					console.log(error);
				}
			};

			getCountries();

			const setCountry = (countryId) => {
				if (!countryId) {
					data.country.id = 0;
					data.country.name = null;
					geoData.countrySelected = false;
					return;
				}
				const foundCountry = multiSelectState.countries.filter(
					(country) => country.id === countryId,
				);
				data.country.id = foundCountry[0].id;
				data.country.name = foundCountry[0].name;
				geoData.countrySelected ? "" : (geoData.countrySelected = true);

				// getting states for selected country
				getPackages(`country=${foundCountry[0].name}`);
				getStates({ country: foundCountry[0].name });
			};

			const getStates = async (stateObj) => {
				let dataObj = {};
				if (stateObj?.country) {
					dataObj.countryName = stateObj.country;
				} else if (stateObj?.name && stateObj?.name.length < 3) {
					return;
				} else {
					dataObj.name = stateObj.name;
				}

				if (data.country.name) {
					dataObj.countryName = data.country.name;
				}

				try {
					const states = await Helper.getStates(dataObj);

					multiSelectState.states = states;

					const changeFormat = states.map((state) => {
						return { label: state.name, value: state.id };
					});

					multiSelectState.statesSelect = [...changeFormat];
				} catch (error) {
					console.log(error);
				}
			};

			const setState = (stateId) => {
				if (!stateId) {
					data.state.id = 0;
					data.state.name = null;
					geoData.stateSelected = false;

					packagesData.packages = [];
					packagesData.packagesFetched = false;
					packagesData.selectedPackage = null;

					return;
				}
				const foundState = multiSelectState.states.filter(
					(state) => state.id === stateId,
				);
				data.state.id = foundState[0].id;
				data.state.name = foundState[0].name;
				geoData.stateSelected ? "" : (geoData.stateSelected = true);
				//getting packages for selected state
				getPackages(`state=${foundState[0].name}`);
			};
			// Country, City, State related Functions end

			//get set packages
			const getPackages = async (query) => {
				packagesData.packages = [];
				packagesData.packagesFetched = false;
				try {
					const { data } = await API.privateRequest.get(
						`packages?${query}&isTemp=true`,
					);
					if (data.data.length < 1) {
						packagesData.packagesFetched = true;
						packagesData.packages = data.data;
						return;
					}
					packagesData.packages = data.data;
					packagesData.packagesFetched = true;

					if (masterStore.state.activeComponent === "edit") {
						const packageData = packagesData.packages.filter(
							(packageObj) => packageObj._id === packagesData.selectedPackage,
						);
						packageEditState.state.data = { ...packageData[0] };
					}
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			const syncStateToLeadState = () => {
				leadState.state.data.package = data;
			};

			const updateItinerary = (itinerary) => {
				let itineraryData = itinerary.map((itinerary) => {
					delete itinerary._id;
					return itinerary;
				});
				data.itinerary = [...itineraryData];
				data.packageData.itineraryDayWise = [...itineraryData];

				syncStateToLeadState();
			};

			const showPackage = (id) => {
				try {
					data.edited = false;

					if (!packagesData.packages.length) return;
					const selectedPackage = packagesData.packages.filter(
						(packageData) => packageData._id === id,
					);
					packageEditState.state.data = { ...selectedPackage[0] };
					if (selectedPackage[0].cities.length) {
						let nights = selectedPackage[0].cities.reduce(
							(previousStay, currentStay) =>
								currentStay.stayNights + previousStay,
							0,
						);

						packagesData.nights = nights;
						packagesData.days = nights + 1;
					}

					data.packageId = id;
					console.log("selected id", data.packageId);
					data.packageData = {
						...selectedPackage[0],
						...packageEditState.state.data,
					};

					setItineraryData();
					// masterStore.methods.changeData(selectedPackage[0]);
				} catch (error) {
					console.log(error);
				}
			};

			const setItineraryData = () => {
				data.itinerary = [...data.packageData.itineraryDayWise];
			};

			const editPackage = (id) => {
				data.packageId = id;
			};

			const setPackageData = () => {
				data.packageData = { ...packageEditState.state.data };
			};

			const changeItineraryCount = () => {
				miscState.itineraryCount = data.itinerary.length - 1;
			};

			watchEffect(() =>
				setPackageData({
					packageData: packageEditState.state.data,
				}),
			);

			const savePackage = async (id) => {
				try {
					const packageData = { ...packageEditState.state.data };
					delete packageData._id;
					packageData?.tags
						? packageData?.tags.map((tag) => delete tag._id)
						: [];
					packageData?.cities
						? packageData?.cities.map((cityItem) => delete cityItem._id)
						: [];
					packageData?.itineraryDayWise
						? packageData?.itineraryDayWise.map((itinerary) => {
								delete itinerary._id;
								if (itinerary?.sightSeeing.length) {
									let sight = itinerary.sightSeeing.map((sight) =>
										sight instanceof Object ? sight._id : sight,
									);
									itinerary.sightSeeing = sight;
								}
						  })
						: [];
					[
						"bronzePackage",
						"platinumPackage",
						"silverPackage",
						"goldPackage",
						"luxuryPackage",
					].map((packageKey) => {
						if (packageData[packageKey] && packageData[packageKey].length) {
							packageData[packageKey].map((keyData) => {
								delete keyData._id;
								if (keyData?.staySights && keyData.staySights.length) {
									keyData.staySights = keyData.staySights.map((staySight) => {
										delete staySight._id;
										if (
											Array.isArray(staySight.hotels) &&
											staySight.hotels.length
										) {
											staySight.hotels = staySight.hotels.map((hotel) =>
												hotel instanceof Object ? hotel._id : hotel,
											);
										}
										return staySight;
									});

									keyData.hotels = [];
								} else if (keyData.hotels.length) {
									keyData.hotels = keyData.hotels.map((hotel) =>
										hotel instanceof Object ? hotel._id : hotel,
									);

									keyData.staySights = [];
								}
								if (keyData.vehicle && keyData.vehicle instanceof Object) {
									keyData.vehicle = keyData.vehicle._id;
								}
							});
							packageData.includedDeal = true;
						}
					});

					data.packageData = { ...packageEditState.state.data };
			
					const response = await API.privateRequest.post("packages", {
						...packageData,
						isTemp: true,
					});
					data.packageId = response.data.data[0]._id;

					leadState.state.data.package = {
						...leadState.state.data.package,
						...data,
					};
					packageEditState.state.data = {
						...packageData,
						_id: response.data.data[0]._id,
					};
				} catch (err) {
					console.log(err);
					console.log("Unable to save package");
				}
			};

			const setEditData = () => {
				const keys = Object.keys(data);
				keys.map(
					(key) => (data[key] = leadState.state.data.package[key] || data[key]),
				);

				data.startDate = leadState.state.data.package?.startDate.split("T")[0];
				data.endDate = leadState.state.data.package?.endDate.split("T")[0];

				multiSelectState.countries = [
					...multiSelectState.countries,
					{
						name: leadState.state.data.package?.country?.name,
						id: leadState.state.data.package?.country?.id,
					},
				];
				multiSelectState.countriesSelect = [
					...multiSelectState.countriesSelect,
					{
						label: leadState.state.data.package?.country?.name,
						value: leadState.state.data.package?.country?.id,
					},
				];

				multiSelectState.states = [
					...multiSelectState.states,
					{
						name: leadState.state.data.package?.state?.name,
						id: leadState.state.data.package?.state?.id,
					},
				];
				multiSelectState.statesSelect = [
					...multiSelectState.statesSelect,
					{
						label: leadState.state.data.package?.state?.name,
						value: leadState.state.data.package?.state?.id,
					},
				];
				getStates({ country: leadState.state.data.package?.country?.name });
				getPackages(`state=${leadState.state.data.package?.state?.name}`);
				// getHotels(`state=${leadState.state.data.package?.state?.name}`);
				data.packageId = leadState.state.data.package?.packageId?._id || null;
				packagesData.selectedPackage =
					leadState.state.data.package?.packageId?._id || null;

				if (data.edited) {
					editPackage(data.packageId);
				}
			};

			if (
				masterStore.state.activeComponent === "edit" &&
				leadState.state.data.package.status
			) {
				setEditData();
			} else {
				leadState.state.data.package = data;
			}

			onBeforeUnmount(() => {
				leadState.state.data.package = { status: false };
				packageEditState.state.data = {};
				packageEditState.state.editBool = false;
				masterStore.methods.setEditBool(false);
			});

			const valSuccess = (input) => {};
			const valError = (input) => {};

			return {
				data,
				masterStore,
				formState,
				leadState,
				multiSelectState,
				geoData,
				packagesData,
				miscState,

				setCountry,
				getStates,
				setState,
				// setHotel,
				updateItinerary,
				showPackage,
				editPackage,
				savePackage,

				valError,
				valSuccess,
			};
		},
	};
</script>